import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ButtonToolbar, Content, Panel, Icon, Button } from 'rsuite';
import PageLayout from '../../../components/reservations/PageLayout';
import PageHeader from '../../../components/PageHeader';
import AccessControl from '../../../components/AccessControl';
import AccessDenied from '../../../components/AccessDenied';
import ExportButton from '../../../components/reservations/ExportButton';
import ReservationSearch from '../../../containers/reservations/Search/Today';
import TodaysReservationList from '../../../containers/reservations/TodaysList';
import PrintReservations from '../../../components/reservations/PrintReservations';
import { getSearchQueryForContext } from '../../../redux/Reservation/selectors/components/search';
import {
  getOrder,
  getItemForBarcode
} from '../../../redux/Reservation/selectors/today';
import {
  getCurrentPageItems,
  getPaginationQueryOptions
} from '../../../redux/Reservation/selectors/today/pagination';
import SearchContext from '../../../constants/reservation/SearchContext';
import RememberListCheckbox from '../../../components/reservations/RememberListCheckbox';
import SmtpAccountDisconnectedMessage from '../../../components/SmtpAccountDisconnectedMessage';
import { useSmtpAccounts } from '../../../hooks/useSmtpAccounts';
import * as PERMISSIONS from '../../../constants/permissions/reservation';
import { EXPORT_TODAY } from '../../../constants/reservation/ExportTypes';
import orderList from '../../../helpers/reservationOrderList';
import { modifyAccess, viewAccess } from '../../../helpers/permission';
import pagePathToUrl from '../../../helpers/pagePathToUrl';
import mergeListQueries from '../../../helpers/mergeListQueries';
import exportReservationsAsCsv from '../../../helpers/exportReservationsAsCsv';
import { reservationsCreatePath, reservationsViewPath } from '../../Paths';
import history from '../../history';

export default () => {
  const { showDisconnectedMessage } = useSmtpAccounts();
  const context = SearchContext.TODAY;
  const [isExporing, setIsExporting] = useState(false);
  const paginationQuery = useSelector(getPaginationQueryOptions);
  const searchQuery = useSelector(state =>
    getSearchQueryForContext(state, context)
  );
  const order = useSelector(getOrder);
  const query = mergeListQueries(paginationQuery, searchQuery, order);
  const { code = '' } = searchQuery;
  const reservation = useSelector(state => getItemForBarcode(state, code));
  const reservations = useSelector(getCurrentPageItems);
  const orderedReservations = orderList(order, reservations);

  const handleExport = async () => {
    setIsExporting(true);
    await exportReservationsAsCsv(EXPORT_TODAY, { ...searchQuery, order });
    setIsExporting(false);
  };

  useEffect(
    () => {
      if (code && reservation) {
        history.push(
          pagePathToUrl(reservationsViewPath, { id: reservation.id })
        );
      }
    },
    [code, reservation]
  );

  return (
    <PageLayout>
      <AccessControl
        allowOnlyFor={viewAccess(PERMISSIONS.MODULE)}
        fallback={<AccessDenied />}
      >
        <PageHeader title="Today's Reservation">
          <Panel bordered>
            <ButtonToolbar style={{ float: 'right' }}>
              <AccessControl allowOnlyFor={modifyAccess(PERMISSIONS.MODULE)}>
                <Link to={reservationsCreatePath}>
                  <Button appearance="primary">
                    <Icon icon="plus-circle" /> Create New
                  </Button>
                </Link>
              </AccessControl>
            </ButtonToolbar>
            <ReservationSearch
              withStatus
              exportButton={
                <ExportButton
                  onClick={handleExport}
                  isLoading={isExporing}
                  style={{ marginRight: 10 }}
                />
              }
              printButton={
                <PrintReservations
                  fileName="todays-reservations"
                  data={orderedReservations}
                />
              }
            />
          </Panel>
        </PageHeader>
        <Content>
          {showDisconnectedMessage && <SmtpAccountDisconnectedMessage />}
          <RememberListCheckbox context={context} query={query} />
          <TodaysReservationList
            actions={['approve', 'reject', 'visit', 'create', 'cancel']}
          />
        </Content>
      </AccessControl>
    </PageLayout>
  );
};
